export default "__VITE_ASSET__OzrT2o9f__"